/**
 * Clerk Provider component for authentication
 */

import React from 'react';
import { ClerkProvider as BaseClerkProvider } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';

// Definir tipos para las variables de entorno
declare global {
  interface ImportMetaEnv {
    readonly VITE_CLERK_PUBLISHABLE_KEY: string;
    readonly VITE_API_BASE_URL: string;
    readonly VITE_APP_ENV: string;
  }

  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }
}

// Clerk publishable key from environment variables
const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

interface ClerkProviderProps {
  children: React.ReactNode;
}

export function ClerkProvider({ children }: ClerkProviderProps) {
  if (!CLERK_PUBLISHABLE_KEY) {
    return (
      <div>
        <div
          style={{
            background: 'orange',
            color: 'white',
            padding: '1rem',
            textAlign: 'center',
          }}
        >
          Warning: VITE_CLERK_PUBLISHABLE_KEY not found in environment
          variables.
          <br />
          Please create a .env.local file with your Clerk publishable key.
        </div>
        {children}
      </div>
    );
  }

  return (
    <BaseClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      appearance={{
        baseTheme: dark,
        variables: {
          colorPrimary: '#10b981', // Grade brand color
          colorDanger: '#ef4444',
          colorSuccess: '#22c55e',
          colorWarning: '#f59e0b',
          fontFamily: 'Inter, system-ui, sans-serif',
          borderRadius: '0.5rem',
        },
        elements: {
          card: 'bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800',
          headerTitle: 'text-gray-900 dark:text-white',
          headerSubtitle: 'text-gray-600 dark:text-gray-400',
          socialButtonsBlockButton:
            'border border-gray-300 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800',
          formFieldLabel: 'text-gray-700 dark:text-gray-300',
          formFieldInput:
            'border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:text-white',
          footerActionText: 'text-gray-600 dark:text-gray-400',
          footerActionLink:
            'text-green-600 hover:text-green-700 dark:text-green-400 dark:hover:text-green-300',
          identityPreviewText: 'text-gray-900 dark:text-white',
          identityPreviewEditButton: 'text-green-600 hover:text-green-700',
        },
      }}
      signInUrl='/auth/sign-in'
      signUpUrl='/auth/sign-up'
      afterSignInUrl='/dashboard'
      afterSignUpUrl='/dashboard'
      navigate={to => (window.location.href = to)}
    >
      {children}
    </BaseClerkProvider>
  );
}
